// extracted by mini-css-extract-plugin
export var icons = "shareComponent-module--icons--KO9kg";
export var shareWrapper = "shareComponent-module--shareWrapper--qTvYv";